module.exports = __webpack_public_path__ + "static/absa-ce91eab64de47180504a0bd6a6b81a9b.png";